import { render } from "./Employments.vue?vue&type=template&id=90ab8ad8"
import script from "./Employments.vue?vue&type=script&lang=js"
export * from "./Employments.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__